module.exports = __webpack_public_path__ + "img/label_blue.62ad34e6.png";